import { ref } from '@vue/composition-api';
import { QueryParamRecord } from '@/bundles/App/type';
import { questionsService } from '@/bundles/Questions/factory/QuestionServiceFactory';
import { Exercise } from '@/helpers/types';

// TODO: prepare correct type
export function useQuestion() {
  const questions = ref([]);
  const total = ref(0);
  const pending = ref(false);
  const createOrUpdateRequestPending = ref(false);

  async function fetch(params: QueryParamRecord[]) {
    pending.value = true;
    const response = await questionsService.list(params);
    questions.value = response.data;
    total.value = response.total;
    pending.value = false;
  }

  async function update(id: string, payload: Exercise) {
    createOrUpdateRequestPending.value = true;
    await questionsService.update(id, payload);
    createOrUpdateRequestPending.value = false;
  }

  async function archive(id: string) {
    await questionsService.archive(id);
  }

  async function create(id: string, payload: Exercise) {
    createOrUpdateRequestPending.value = true;
    await questionsService.create(payload);
    createOrUpdateRequestPending.value = false;
  }

  return {
    questions,
    total,
    pending,
    createOrUpdateRequestPending,
    fetch,
    update,
    archive,
    create,
  };
}
